import { useCallback, useEffect } from 'react';

import { useMeOrg } from './useMeOrg';
import { useMeOrgCommand } from './useMeOrgCommand';

type Props = {
  organizationId: string;
};

export const useMeOrgSelector = (props: Props) => {
  const {
    getMyOrganization: { getOrganization, getOrgLoading: loading },
  } = useMeOrgCommand();

  const { org } = useMeOrg();

  const fetchData = useCallback(async () => {
    if (!props.organizationId) {
      return null;
    }

    try {
      const res = await getOrganization(props.organizationId);

      return res.organization;
    } catch (error) {
      // Ignore abort errors - they happen when component unmounts during fetch
      if (error instanceof Error && error.name === 'AbortError') {
        return null;
      }

      throw error;
    }
  }, [getOrganization, props.organizationId]);

  useEffect(() => {
    if (!props.organizationId) {
      return;
    }

    if (!org?.id) {
      void fetchData();
    }
  }, [props.organizationId, org?.id, fetchData]);

  return { org, loading };
};
